<template>
  <div class="app-admin-page">
    <div class="app-admin-card">
      <div class="toolbar">
        <div class="page-title">论坛分类管理</div>
        <div>
          <el-button icon="el-icon-refresh" @click="getCategories">刷新</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="openForm()">添加分类</el-button>
        </div>
      </div>

      <el-table :data="list" height="76vh" border style="width: 100%">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="name" label="分类名称" min-width="180"></el-table-column>
        <el-table-column label="图标" min-width="220">
          <template slot-scope="scope">
            <i :class="scope.row.icon"></i>
            <span class="icon-text">{{ scope.row.icon }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="120"></el-table-column>
        <el-table-column label="启用" width="120">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.enabled"
              :active-value="1"
              :inactive-value="0"
              @change="saveCategory(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openForm(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :title="form.id ? '编辑分类' : '添加分类'" :visible.sync="visible" width="460px">
      <el-form :model="form" label-width="90px">
        <el-form-item label="分类名称">
          <el-input v-model="form.name" maxlength="30" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="图标类名">
          <el-input v-model="form.icon" placeholder="fa-solid fa-comments"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort" :min="0" :step="1" style="width: 100%"></el-input-number>
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="form.enabled" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { post } from "../axios/request.js";
import { isSuccess } from "./appAdminUtils.js";

export default {
  name: "forumCategory",
  data() {
    return {
      list: [],
      visible: false,
      form: {
        id: "",
        name: "",
        icon: "fa-solid fa-comments",
        sort: 0,
        enabled: 1,
      },
    };
  },
  mounted() {
    this.getCategories();
  },
  methods: {
    getCategories() {
      post("/api/admin/forum/categories", {}).then((res) => {
        if (isSuccess(res)) {
          this.list = res.data.data || [];
        } else {
          this.$message.error(res.data.msg || "分类列表获取失败");
        }
      });
    },
    openForm(row) {
      if (row) {
        this.form = {
          id: row.id,
          name: row.name,
          icon: row.icon || "fa-solid fa-comments",
          sort: Number(row.sort) || 0,
          enabled: Number(row.enabled) === 1 ? 1 : 0,
        };
      } else {
        this.form = {
          id: "",
          name: "",
          icon: "fa-solid fa-comments",
          sort: 0,
          enabled: 1,
        };
      }
      this.visible = true;
    },
    submitForm() {
      if (!this.form.name) {
        this.$message.error("请填写分类名称");
        return;
      }
      this.saveCategory(this.form, true);
    },
    saveCategory(row, closeDialog) {
      post("/api/admin/forum/savecategory", {
        id: row.id,
        name: row.name,
        icon: row.icon || "fa-solid fa-comments",
        sort: Number(row.sort) || 0,
        enabled: Number(row.enabled) === 1 ? 1 : 0,
      }).then((res) => {
        if (isSuccess(res)) {
          this.$notify({ title: "保存成功", message: res.data.msg, type: "success" });
          if (closeDialog) {
            this.visible = false;
          }
          this.getCategories();
        } else {
          this.$message.error(res.data.msg || "保存失败");
          this.getCategories();
        }
      });
    },
  },
};
</script>

<style scoped>
.app-admin-page {
  width: 100%;
  height: 100%;
  background: #f5f7fb;
  overflow: auto;
}
.app-admin-card {
  width: 98%;
  height: 95%;
  margin: 1.5% auto;
  padding: 22px;
  background: #fff;
  box-shadow: #e0e0e0 5px 5px 10px;
  box-sizing: border-box;
}
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}
.page-title {
  font-size: 22px;
  color: #1f2d3d;
  font-weight: 700;
}
.icon-text {
  margin-left: 8px;
  color: #606266;
}
</style>
